<template>
  <div>
    <el-form :disabled="readonly" class="section top" style="flex-direction: row;min-width: 1600px;">
      <el-checkbox
        v-model="job.warehousing"
        no="1"
        @change="loadingTerm_Change('warehousing')"
      >{{ $t('SeaExport.WarehouseLoadingStorage') }}</el-checkbox>
      <el-checkbox
        v-model="job.landTransportation"
        no="2"
        @change="loadingTerm_Change('landTransportation')"
      >{{ $t('SeaExport.DoorLoadingDelivery') }}</el-checkbox>
      <el-checkbox v-model="job.selfDeliver" no="3">{{ $t('SeaExport.NotResponsibleForTruckingAndLoading') }}</el-checkbox>
      <el-checkbox v-model="job.ams" no="4">AMS/ENS</el-checkbox>
      <el-checkbox v-model="job.heating" no="5">{{ $t('SeaExport.Fumigation') }}</el-checkbox>
      <el-checkbox v-model="job.comercialInspectation" no="6">{{ $t('SeaExport.CommodityInspection') }}</el-checkbox>
      <el-checkbox v-model="job.customs" no="7" @change="val=>{job.customsBroker=val?job.customsBroker:0;job.customsDeclarationType=val?job.customsDeclarationType:-1}">{{ $t('SeaExport.CustomsDeclaration') }}</el-checkbox>
      <el-checkbox v-model="job.signMBL" no="8">MB/L</el-checkbox>
      <el-checkbox v-model="job.signHBL" no="9" :disabled="job.mblOnly">HB/L</el-checkbox>
      <el-checkbox v-model="job.mblOnly" no="10" @change="mblOnlyChange">{{ $t('Message.DirectBusiness') }}</el-checkbox>
      <el-checkbox v-model="job.salePrice" no="11">{{ $t('SeaExport.SpecialPrice') }}</el-checkbox>
      <el-checkbox v-model="job.availableCabinSpace" no="12">{{ $t('CargoMsg.Cargo_AvailableCabinSpace') }}</el-checkbox>
      <el-checkbox v-model="job.destinationPortService" no="destinationPortService" @change="destinationPortServiceChange">{{ $t('SeaExport.PortOfDestinationServices') }}</el-checkbox>
    </el-form>
    <div class="section top" style="min-width: 1600px;">
      <span class="title">{{ $t('CargoMsg.Cargo_BasicInfo') }}</span>
      <el-form
        :disabled="readonly"
        :inline="true"
        label-width="135px"
        label-position="left"
      >
        <el-form-item :label="$t('CargoMsg.Cargo_BusinessNo')" label-width="125px">
          <el-input v-model="job.jobNo" no="12" :disabled="true" class="job-no-color input2" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_WarehouseNo')">
          <el-input v-model="job.warehouseNo" no="13" class="input2" />
        </el-form-item>
        <el-form-item :label="$t('SeaExport.quotationNum')">
          <el-input no="14" :value="job.quotationNo" class="input2" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('Payment.businessReferenceNumber')" label-width="100px">
          <cargo-input v-model="job.customerRefNo" no="15" class="input2" :trim="true" />
        </el-form-item>
      </el-form>
      <div>
        <div>
          <el-form :disabled="readonly" :inline="true" label-width="135px" label-position="left">
            <el-form-item label-width="125px">
              <span slot="label" class="blue">{{ $t('Payment.consignationCompany') }}</span>
              <cargo-sales-company-select
                v-if="accountObjectControlMode === 2"
                no="16"
                :disabled="!(!job.mbl&&electricBusinessBtnEnable)"
                :method-params="{customer:true,active:true}"
                :check-credit="true"
                :job="job"
                :default-value="job.customerId||''"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="p=>{txtCustomerId_changeHandler(p);clearPoNo()}"
              />
              <cargo-company-select
                v-else
                no="16"
                :disabled="!(!job.mbl&&electricBusinessBtnEnable)"
                :method-params="{customer:true,active:true}"
                :check-credit="true"
                :job="job"
                :default-value="job.customerId||''"
                :static-options="customerCmpList"
                :placeholder="$t('SeaExport.RequiredItem')"
                :custom-style="'width:260px'"
                @change="p=>{txtCustomerId_changeHandler(p);clearPoNo()}"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.contactPerson')">
              <el-select
                v-model="job.customerContact"
                no="17"
                class="input2"
                :disabled="!electricBusinessBtnEnable"
                filterable
                :allow-create="true"
                placeholder=""
                @change="tfLinkman_closeHandler"
              >
                <el-option
                  v-for="(item,index) in contactList"
                  :key="index"
                  :label="item.contactPerson"
                  :value="item.contactPerson"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-show="!isShowContactPersonDetail" :label="$t('SeaExport.Tel')">
              <el-input
                v-model="job.contactTelephone"
                no="18"
                class="input2"
                :disabled="!electricBusinessBtnEnable"
                maxlength="32"
              />
            </el-form-item>
            <el-form-item v-show="!isShowContactPersonDetail" :label="$t('SeaExport.Fax')" label-width="100px">
              <el-input
                v-model="job.contactFax"
                no="19"
                class="input2"
                :disabled="!electricBusinessBtnEnable"
                maxlength="32"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" :inline="true" label-width="135px" label-position="left">
            <el-form-item class="blue" label-width="125px">
              <span slot="label" class="blue">{{ $t('Payment.sales') }}</span>
              <cargo-user-select
                no="20"
                class="input2"
                :disabled="!(!job.trustFromJob&&electricBusinessBtnEnable&&(!validateCustomerSales||(isSpecifiedSalesBusiness&&validateCustomerSales)))"
                :method-params="{officeId:!isSpecifiedSalesBusiness&&salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                :default-value="job.sales||''"
                :static-options="salesList"
                :placeholder="$t('SeaExport.RequiredItem')"
                :merge-load="true"
                @change="txtSales_changeHandler"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('queryJob.salesDepartment') }}</span>
              <cargo-department-new-select
                no="21"
                class="input2"
                :disabled="!(job.sales>0&&job.salesDepartment>0)"
                :sales-id="job.sales"
                :office-id="job.salesOffice"
                :department-id="job.salesDepartment"
                :show-office-prefix="false"
                placeholder=" "
                @change="p=>{job.salesDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item class="blue">
              <span slot="label" class="blue">{{ $t('SeaExport.SalesCompany') }}</span>
              <el-input v-model="txtSalesOffice" no="22" :disabled="true" :placeholder="$t('SeaExport.RequiredItem')" class="input2" />
            </el-form-item>
            <el-form-item :label="$t('Payment.customerService')" label-width="100px">
              <cargo-user-select
                no="23"
                class="input2"
                :disabled="Boolean(job.trustFromJob)"
                :method-params="{category:'role',shape:'csr',officeId:job.opOffice}"
                :default-value="job.csr||''"
                :static-options="userPortRoleData.csr || csrList"
                placeholder=" "
                :merge-load="true"
                @change="csrChangeHandler"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" :inline="true" label-width="135px" label-position="left">
            <el-form-item :label="$t('FileHistory.operation')" label-width="125px">
              <cargo-user-select
                no="24"
                class="input2"
                :disabled="Boolean(job.trustFromJob)"
                :method-params="{category:'role',shape:'op',officeId:$store.getters.currentOfficeId}"
                :default-value="job.op||''"
                placeholder=" "
                :static-options="userPortRoleData.op"
                :merge-load="true"
                @change="txtOPChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.operationDepartment')">
              <cargo-department-select
                no="25"
                class="input2"
                :disabled="Boolean(job.trustFromJob)"
                :office-id="job.opOffice"
                :enables="true"
                :department-id="job.opDepartment"
                placeholder=" "
                @change="p=>{job.opDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-advance-select
                no="26"
                class="input2"
                :disabled="isEntrustOrder()"
                :select-type="TYPE_NAMES.basic_data_Office"
                filterable
                :default-value="job.opOffice||''"
                placeholder=" "
                @parentCallBack="p=>{job.opOffice=p.value;opOfficeChargeHandler()}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')" label-width="100px">
              <cargo-user-select
                no="27"
                class="input2"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'siteOp'}"
                :default-value="job.siteOP||''"
                placeholder=" "
                :static-options="userPortRoleData.siteOp"
                :merge-load="true"
                @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" :inline="true" label-width="135px" label-position="left">
            <el-form-item :label="$t('SeaExport.SalesOfGoods')" label-width="125px">
              <cargo-user-select
                no="28"
                class="input2"
                :method-params="{category:'role',shape:'salesOfGoods'}"
                :default-value="job.cargoSalesId||''"
                :static-options="cargoSalesList"
                placeholder=" "
                :merge-load="true"
                @change="cargoSalesChargeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('queryJob.Documents')">
              <cargo-user-select
                no="29"
                class="input2"
                :disabled="Boolean(job.trustFromJob)"
                :method-params="{category:'role',shape:'doc',officeId:$store.getters.currentOfficeId}"
                :default-value="job.dc||''"
                :static-options="userPortRoleData.doc || dcList"
                placeholder=" "
                :merge-load="true"
                @change="dcChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('Payment.planner')">
              <cargo-user-select
                no="30"
                class="input2"
                :method-params="{category:'role',shape:'sealine',officeId:$store.getters.currentOfficeId}"
                :default-value="job.planner||''"
                placeholder=" "
                :static-options="userPortRoleData.seaLine"
                :merge-load="true"
                @change="txtPlannerChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseaCustomerService')" label-width="100px">
              <cargo-user-select
                ref="overseaOp"
                no="overseaOp"
                class="input2"
                placeholder=" "
                :default-value="job.overseaOp||''"
                :method-params="{category:'role',shape:'overseaOp'}"
                :static-options="isHc ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
                :merge-load="true"
                @change="p=>{
                  job.overseaOp = p.value
                  OverseaCustomerUtils.overseaOpChangeHandler(view, p)
                }"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" :inline="true" label-width="135px" label-position="left">
            <el-form-item :label="$t('Message.Customer_Service')" label-width="125px">
              <cargo-department-select
                no="csrDepartment"
                class="input2"
                :office-id="Number(job.csrOffice)"
                :enables="true"
                :department-id="Number(job.csrDepartment)"
                @change="p=>{job.csrDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerOffice')">
              <cargo-advance-select
                no="csrOffice"
                class="input2"
                :disabled="true"
                :select-type="TYPE_NAMES.basic_data_Office"
                filterable
                :default-value="job.csrOffice||''"
                @parentCallBack="p=>{job.csrOffice=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('Message.Documentation_Department')">
              <cargo-department-select
                no="dcDepartment"
                class="input2"
                :office-id="Number(job.dcOffice)"
                :enables="true"
                :department-id="Number(job.dcDepartment)"
                @change="p=>{job.dcDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DocumentOffice')" label-width="100px">
              <cargo-advance-select
                no="dcOffice"
                class="input2"
                :disabled="true"
                :select-type="TYPE_NAMES.basic_data_Office"
                filterable
                :default-value="job.dcOffice||''"
                @parentCallBack="p=>{job.dcOffice=p.value}"
              />
            </el-form-item>
          </el-form>
          <el-form :disabled="readonly" :inline="true" label-width="135px" label-position="left">
            <el-form-item :label="$t('Payment.itemNo')" label-width="125px" :class="poNoRed?'poNoClass':''">
              <el-input v-if="!openProjectConfig" v-model="job.poNo" no="31" class="input2" />
              <cargo-project-select
                v-if="openProjectConfig"
                no="32"
                :default-value="job.poNo"
                :customer-id="job.customerId"
                :is-linked="isProjectLinkedCustomer"
                class="input2"
                @change="changeProject"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineDepartment')">
              <cargo-department-select
                no="plannerDepartment"
                class="input2"
                :office-id="Number(job.plannerOffice)"
                :enables="true"
                :department-id="Number(job.plannerDepartment)"
                @change="p=>{job.plannerDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineOffice')">
              <cargo-advance-select
                no="plannerOffice"
                class="input2"
                :disabled="true"
                :select-type="TYPE_NAMES.basic_data_Office"
                filterable
                :default-value="job.plannerOffice||''"
                @parentCallBack="p=>{job.plannerOffice=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="openProjectConfig" :label="$t('SeaExport.ProjectName')">
              <el-input v-model="job.projectName" no="33" :disabled="true" class="input2" />
            </el-form-item>
            <el-form-item v-if="openProjectConfig" :label="$t('SeaExport.ProjectBatch')">
              <el-input v-model="job.projectBatch" no="34" class="input2" />
            </el-form-item>
          </el-form>
          <el-form v-if="isAddUserDefinedRoles" :disabled="readonly" :inline="true" label-width="135px" label-position="left">
            <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole1')" label-width="125px">
              <cargo-user-select
                no="35"
                class="input2"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="job.userDefinedRoleId1||''"
                placeholder=" "
                :static-options="userPortRoleData.userDefinedRole1"
                :merge-load="true"
                @change="userDefinedRoleId1Handler"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                no="36"
                class="input2"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                :default-value="job.userDefinedRoleId2||''"
                placeholder=" "
                :static-options="userPortRoleData.userDefinedRole2"
                @change="userDefinedRoleId2Handler"
              />
            </el-form-item>
          </el-form>
        </div>
        <div v-show="job.preverifyState===3" style="display: flex;">
          <span style="width: 100px; display:inline-block">{{ $t('CargoMsg.Cargo_DenialReason') }}</span>
          <el-input v-model="job.bookingRefuseNote" no="37" type="textarea" style="width: 260px" :rows="3" :disabled="true" />
        </div>
      </div>
    </div>
    <div class="section" style="min-width: 1600px;">
      <span class="title">{{ $t('CargoMsg.Cargo_ShippingInformation') }}</span>
      <div class="form-item-w260" style="display: flex;flex-direction: row;">
        <el-form
          :disabled="readonly"
          label-width="125px"
          label-position="left"
          style="margin-right:10px"
        >
          <el-form-item :label="$t('SeaExport.Shipper')" class="auto-width">
            <cargo-company-select
              no="38"
              :disabled="readonly"
              :method-params="{shipper:true,active:true}"
              :default-value="job.shipperId||''"
              placeholder=" "
              :static-options="hasChooseOwnTransceiverPermission ? privateShipperList : null"
              :class="isZh?'shipper-input':'shipper-input-en'"
              @change="shipperChange"
            />&nbsp;
            <el-button
              no="39"
              type="primary"
              @click="billAddressDialog.visible=true"
            >{{ $t('SeaExport.CodeSearching') }}</el-button>
          </el-form-item>
          <el-form-item v-for="i in 7" :key="i" class="auto-width">
            <cargo-input
              :ref="'shipperLine'+i"
              v-model="job['shipperLine'+i]"
              no="40"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              @change="()=>wrapAddr(job,'shipperLine'+i,i+1 > 7 ? null :'shipperLine'+(i+1),200)"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine,true)"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.DateOfDeparture') }}</span>
            <el-date-picker v-model="job.etd" no="41" type="date" value-format="yyyy-MM-dd" clearable :placeholder="$t('SeaExport.RequiredItem')" @input="etdChange" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ArrivalTime')">
            <el-date-picker v-model="job.eta" no="42" type="date" value-format="yyyy-MM-dd" clearable />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CYCutOffDate2')">
            <el-date-picker
              v-model="job.customCutoff"
              no="43"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
            />
          </el-form-item>
          <el-form-item v-show="job.ams" :label="$t('CargoMsg.Cargo_AmsEnsCyCutOffDate')">
            <el-date-picker
              v-model="job.amsCutoff"
              no="44"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_StartDateOfContainerReturn')">
            <el-date-picker
              v-model="job.returnPeriodBegin"
              no="45"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CloseDateOfContainerReturn')">
            <el-date-picker
              v-model="job.returnPeriodEnd"
              no="46"
              type="datetime"
              format="yyyy-MM-dd HH:mm"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfReceipt')">
            <el-input
              v-model="job.dispatchingPlace"
              no="47"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.PortOfLoading') }}</span>
            <div style="display: flex;justify-content: space-between">
              <cargo-advance-select
                no="48"
                filterable
                :select-type="TYPE_NAMES.basic_data_Seaport"
                :default-value="job.loadingPortCode"
                :placeholder="$t('SeaExport.RequiredItem')"
                class="port-item"
                :style="{width:isZh?'':'190px',minWidth:isZh?'':'190px'}"
                @parentCallBack="loadingPortCode_Change"
              />
              <el-checkbox
                v-model="job.transfering"
                no="49"
                style="margin: 0 0 0 10px;"
              >{{ $t('SeaExport.Transit') }}</el-checkbox>
            </div>
          </el-form-item>
          <!-- 中转港 -->
          <el-form-item v-show="job.transfering" :label="$t('SeaExport.TransitPort')">
            <cargo-advance-select
              no="50"
              :select-type="TYPE_NAMES.basic_data_Seaport"
              filterable
              :default-value="job.transferPortCode"
              :placeholder="$t('SeaExport.RequiredItem')"
              @parentCallBack="p=>{job.transferPortCode = p.value}"
            />
          </el-form-item>
          <!-- 卸货港 -->
          <el-form-item>
            <span slot="label" class="blue">{{ $t('SeaExport.PortOfDischarge') }}</span>
            <cargo-advance-select
              no="51"
              :disabled="!(!job.mbl&&electricBusinessBtnEnable)"
              :select-type="TYPE_NAMES.basic_data_Seaport"
              filterable
              :default-value="job.dischargingPortCode"
              :placeholder="$t('SeaExport.RequiredItem')"
              @parentCallBack="p=>{dischargingPortCodeChange(p)}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" class="blue">{{ $t('queryJob.placeOfDelivery') }}</span>
            <cargo-advance-select
              no="52"
              :select-type="TYPE_NAMES.basic_data_Seaport"
              filterable
              :default-value="job.destinationPortCode"
              :placeholder="$t('SeaExport.RequiredItem')"
              @parentCallBack="p=>{destinationPortCode_Change(p);}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label">{{ $t('CargoMsg.Cargo_PlaceOfDeliveryRegion') }}</span>
            <cargo-advance-select
              no="117"
              :select-type="TYPE_NAMES.basic_data_Region"
              filterable
              :default-value="job.placeOfDeliveryRegion"
              @parentCallBack="p=>{job.placeOfDeliveryRegion=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.FinalDestination')">
            <el-input
              v-model="job.destinationPlace"
              no="53"
              @change="changeDestinationPlace"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.SolicitationType')">
            <cargo-advance-select
              no="54"
              filterable
              :select-type="TYPE_NAMES.local_cache_CargoSource"
              :default-value="job.cargoSource"
              :clearable="false"
              @parentCallBack="p=>{job.cargoSource=p.value;cargoSource_Change();txtCargoSourceChangeHandler()}"
            />
          </el-form-item>
          <el-form-item v-if="job.cargoSource === 'NC'" id="agentRefNo" :label="$t('SeaExport.NCReferenceNo')">
            <el-input v-model="job.agentRefNo" no="agentRefNo" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomJobType')">
            <cargo-advance-select
              ref="customJobType"
              no="55"
              filterable
              :select-type="TYPE_NAMES.basic_data_CutomJobType"
              :method-params="{type:job.lob, active: true}"
              :default-value="job.customJobType"
              :placeholder="$t('Message.PleaseSelect')"
              @parentCallBack="p=>{job.customJobType=p.value;onCustomJobTypeChange()}"
            />
          </el-form-item>
          <el-form-item :label="$t('Payment.destinationAgent')">
            <cargo-advance-select
              no="56"
              :select-type="TYPE_NAMES.basic_data_Company"
              filterable
              :method-params="{overseaAgent:true,companyLob:'seaExport',active:true}"
              :default-value="job.destinationAgent||''"
              placeholder=" "
              @parentCallBack="txtDestinationAgentChangeHandler"
            />
          </el-form-item>
          <el-form-item v-show="job.cargoSource==='NC'">
            <span slot="label" class="blue">{{ $t('queryJob.nominatedAgent') }}</span>
            <cargo-company-select
              no="57"
              :method-params="{designationAgent:true,active:true}"
              :check-credit="true"
              :job="job"
              :default-value="job.designationAgent||''"
              tag-name="englishName"
              placeholder=" "
              style="width:300px;"
              @change="txtDesignationAgentChangeHandler"
            />
          </el-form-item>
          <el-form-item v-show="bookingAgentVisible" :label="$t('queryJob.bookingAgent')">
            <cargo-advance-select
              no="58"
              filterable
              :select-type="TYPE_NAMES.basic_data_Company"
              :method-params="{bookingAgent:true,companyLob:'seaExport',active:true}"
              :default-value="job.bookingAgent || ''"
              placeholder=" "
              @parentCallBack="bookingAgentChangeHandler"
            />
          </el-form-item>
          <!-- 码头公司 -->
          <el-form-item :label="$t('Message.TerminalCompany')">
            <cargo-company-select
              no="terminalCompany"
              :method-params="{terminalCompany:true,companyLob:'seaExport',active:true}"
              :default-value="job.terminalCompany||''"
              style="width: 100%"
              @change="p=>{JobUtils.terminalCompanyChangeHandler(job, p)}"
            />
          </el-form-item>
          <!-- 船公司 -->
          <el-form-item :label="$t('SeaExport.ShippingCompany')">
            <cargo-advance-select
              no="59"
              filterable
              :select-type="TYPE_NAMES.basic_data_Company"
              :method-params="{seaCmp:true,companyLob:'seaExport',active:true}"
              :default-value="job.carrierId || ''"
              placeholder=" "
              @parentCallBack="carrierChangeHandler"
            />
          </el-form-item>
          <el-form-item :label="$t('queryJob.shippingCompanyContractNo')">
            <el-input v-model="job.scNo" no="60" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CargoType')">
            <cargo-advance-select
              no="61"
              filterable
              :select-type="TYPE_NAMES.basic_data_CargoType"
              :method-params="{sea:true}"
              :default-value="job.cargoType"
              :clearable="false"
              @parentCallBack="p=>{job.cargoType=p.value;onCargoTypeChange()}"
            />
          </el-form-item>
          <el-form-item :label="$t('queryJob.masterBLFreightTerm')">
            <cargo-require-advance-select
              no="62"
              filterable
              :select-type="TYPE_NAMES.basic_data_PaymentTerm"
              :default-value="job.paymentTermMBL"
              :clearable="false"
              @parentCallBack="p=>{job.paymentTermMBL=p.value;portChange()}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfMblPayment')">
            <el-input
              v-model="mblDoc.paymentPlaceBL"
              no="63"
              :disabled="job.paymentTermMBL==='CC'||job.paymentTermMBL==='PPAC'"
            />
          </el-form-item>
          <el-form-item v-show="!job.mblOnly" :label="$t('queryJob.HBLFreightClause')">
            <cargo-require-advance-select
              no="64"
              :select-type="TYPE_NAMES.basic_data_PaymentTerm"
              filterable
              :clearable="false"
              :default-value="job.paymentTermHBL"
              @parentCallBack="p=>{job.paymentTermHBL=p.value;portChange()}"
            />
          </el-form-item>
          <el-form-item v-show="!job.mblOnly" :label="$t('SeaExport.PlaceOfHblPayment')">
            <el-input v-model="hdoc.paymentPlaceBL" no="65" />
          </el-form-item>
        </el-form>
        <el-form
          :disabled="readonly"
          label-width="135px"
          label-position="left"
          style="margin-right:10px"
        >
          <el-form-item :label="$t('SeaExport.Consignee')" class="auto-width">
            <cargo-company-select
              no="66"
              :disabled="readonly"
              :method-params="{consignee:true,active:true}"
              :default-value="job.consigneeId||''"
              placeholder=" "
              :static-options="hasChooseOwnTransceiverPermission ? privateConsigneeList : null"
              :class="isZh?'shipper-input':'shipper-input-en'"
              @change="consigneeChange"
            />&nbsp;
            <el-button
              no="67"
              type="primary"
              @click="billAddressDialog.visible=true"
            >{{ $t('SeaExport.CodeSearching') }}</el-button>
          </el-form-item>
          <el-form-item v-for="i in 7" :key="i" class="auto-width">
            <cargo-input
              :ref="'consigneeLine'+i"
              v-model="job['consigneeLine'+i]"
              no="68"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              @change="()=>wrapAddr(job,'consigneeLine'+i,i+1 > 7 ? null :'consigneeLine'+(i+1),200)"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),splitConsigneeLine,true)"
            />
          </el-form-item>
          <el-form-item :label="$t('Payment.vessel')">
            <cargo-advance-select
              no="69"
              :select-type="TYPE_NAMES.static_data_Vessel"
              :cache="false"
              filterable
              :allow-create="true"
              :default-value="job.vessel"
              :static-options="vesselList"
              placeholder=" "
              @parentCallBack="onVesselSelectionChange"
            />
          </el-form-item>
          <el-form-item :label="$t('Payment.voyage')">
            <cargo-advance-select
              ref="voyageFlight"
              no="70"
              :cache="false"
              filterable
              clearable
              :allow-create="true"
              :default-value="job.voyageFlight"
              tag-name="voyageNo"
              tag-value="voyageNo"
              :static-options="voyages"
              placeholder=" "
              @focus="txtVoyageFocusInHandler"
              @parentCallBack="p=>{job.voyageFlight=p.value}"
            />
          </el-form-item>
          <el-form-item label="IMO">
            <el-input v-model="job.vesselIMO" no="71" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_FeederOrNot')">
            <div style="display: flex">
              <el-checkbox v-model="showBargeCustomCutoff" no="72" />
              <div v-show="showBargeCustomCutoff">
                <span>驳船{{ $t('SeaExport.BargeCYCutOffDate2') }}</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item v-show="showBargeCustomCutoff">
            <el-date-picker
              v-model="job.bargeCustomCutoff"
              no="73"
              type="date"
              value-format="yyyy-MM-dd"
              clearable
            />
          </el-form-item>
          <el-form-item v-show="showBargeCustomCutoff" :label="$t('SeaExport.BargePOL')">
            <el-input v-model="job.bargePOL" no="74" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_AirlineCode')">
            <el-input v-model="job.vesselLineCode" no="75" />
          </el-form-item>
          <el-form-item>
            <el-radio-group v-model="job.containerLoadType" no="76" @change="containerLoadType_Change()">
              <el-radio label="FCL">{{ $t('CargoMsg.Cargo_FCL') }}</el-radio>
              <el-radio label="LCL">{{ $t('CargoMsg.Cargo_DirectConsol') }}</el-radio>
              <el-radio label="BB">{{ $t('CargoMsg.Cargo_CoLoadConsol') }}</el-radio>
              <el-radio label="BC">Buyer Console</el-radio>
              <el-radio label="BULK">{{ $t('CargoMsg.Cargo_BulkCargo') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-show="job.containerLoadType==='FCL'||job.containerLoadType==='BB'"
            class="auto-width"
          >
            <booking-sea-eq-data-grid
              ref="bookingSeaEqDataGrid"
              :value="seaEqList"
              :container-load-type="job.containerLoadType"
              :is-edit="isEdit"
              :job="job"
              :hide-soc="true"
              style="width: 260px"
            />
          </el-form-item>
          <el-form-item
            v-show="job.containerLoadType==='FCL'||job.containerLoadType==='BB'"
            label-width="0"
            class="auto-width"
            :style="{width:'50%',marginTop:isEdit?'-40px':''}"
          >
            <el-checkbox v-model="job.soc" :style="{marginRight:'10px'}" @change="socChange">{{ $t('SeaExport.Soc') }}</el-checkbox>
            <el-radio-group v-show="job.soc" v-model="job.socType" no="118" :style="{display:'flex',marginTop: '2px'}">
              <el-radio :label="1">{{ $t('CargoMsg.CargoOwnerSOC') }}</el-radio>
              <el-radio :label="2">{{ $t('CargoMsg.ForwarderSOC') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label-width="0" class="auto-width">
            <div class="short-item-input" style="width: auto">
              <label style="width: 135px">{{ $t('SeaExport.CommissionedNumberOfPackages') }}</label>
              <div class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <auto-number-input
                  v-model="job.quantityContract"
                  no="77"
                  :precision="0"
                  :min="0"
                  @change="quantityContractChange"
                />
                <span>&nbsp;</span>
              </div>
              <label>{{ $t('SeaExport.ActualQuantity') }}</label>
              <div class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <auto-number-input
                  v-model="job.quantityActual"
                  no="78"
                  :precision="0"
                  :min="0"
                  @change="quantityActualChange"
                />
                <span>&nbsp;</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label-width="0" class="auto-width">
            <div class="short-item-input" style="width: auto">
              <label style="width: 135px">{{ $t('SeaExport.CommissionedGrossWeight') }}</label>
              <div class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <auto-number-input
                  v-model="job.weightContract"
                  no="79"
                  :precision="3"
                  :min="0"
                  @change="weightContractChange"
                />
                <span>KGS</span>
              </div>
              <label>{{ $t('SeaExport.ActualWeight') }}</label>
              <div class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <auto-number-input
                  v-model="job.weightActual"
                  no="80"
                  :precision="3"
                  :min="0"
                  @change="weightActualChange"
                />
                <span>KGS</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label-width="0" class="auto-width">
            <div class="short-item-input" style="width: auto">
              <label style="width: 135px">{{ $t('SeaExport.CommissionedVolume') }}</label>
              <div class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <auto-number-input
                  v-model="job.cubageContract"
                  no="81"
                  :precision="3"
                  :min="0"
                  @change="cubageContractChange"
                />
                <span>M³</span>
              </div>
              <label>{{ $t('SeaExport.ActualVolume') }}</label>
              <div class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <auto-number-input
                  v-model="job.cubageActual"
                  no="82"
                  :precision="3"
                  :min="0"
                  @change="cubageActualChange"
                />
                <span>M³</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Package')" class="auto-width">
            <cargo-packing-select
              no="83"
              :disabled="readonly"
              :default-value="job.packing"
              placeholder=" "
              style="width: 260px;"
              @change="p=>{job.packing=p.value}"
            />
          </el-form-item>
          <el-form-item label-width="0" class="auto-width">
            <div class="short-item-input" style="width: auto">
              <label :style="{width: isZh ? '135px' : '95px'}">{{ $t('SeaExport.Pieces') }}</label>
              <div class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <auto-number-input
                  v-model="job.insideQuantity"
                  no="84"
                  :precision="0"
                  :min="0"
                />
              </div>
              <label :style="{width: isZh ? '65px' : '105px'}">{{ $t('SeaExport.ChargedWeight') }}</label>
              <div class="short-input" :class="readonly ? 'short-input-disabled' : ''">
                <el-input-number
                  v-model="job.chargeWeight"
                  no="85"
                  :controls="false"
                  :precision="3"
                />
                <span>M/T</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PiecesType')">
            <cargo-packing-select
              no="86"
              :disabled="readonly"
              :default-value="job.insidePacking"
              placeholder=" "
              style="width:260px"
              @change="p=>{job.insidePacking=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Size')">
            <el-input
              v-model="job.measurements"
              no="87"
              type="textarea"
              :rows="3"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Size'),job.measurements,val=>{job.measurements=val})"
            />
          </el-form-item>
          <el-form-item v-show="job.salePrice" :label="$t('SeaExport.SpecialPriceInstructions')">
            <el-input v-model="job.salePriceRemarks" no="88" type="textarea" :rows="3" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.MBLTransportationClause')">
            <cargo-advance-select
              no="89"
              :select-type="TYPE_NAMES.basic_data_ShippingTerm"
              filterable
              :clearable="false"
              :default-value="job.freightTerm"
              @parentCallBack="p=>{job.freightTerm=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.HBLTransportationClause')">
            <cargo-advance-select
              no="90"
              :select-type="TYPE_NAMES.basic_data_ShippingTerm"
              filterable
              :clearable="false"
              :default-value="job.freightTermHBL"
              @parentCallBack="p=>{job.freightTermHBL=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('queryJob.IncoTerm')">
            <cargo-advance-select
              no="91"
              :select-type="TYPE_NAMES.basic_data_IncoTerm"
              filterable
              :clearable="false"
              :default-value="job.incoTerm"
              @parentCallBack="p=>{job.incoTerm=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContractRateProperty')">
            <cargo-require-select
              v-model="job.bookingTerm"
              no="92"
              :options="bookingTerms"
              :label-field="isZh?'chineseName':'englishName'"
              value-field="code"
              :clearable="false"
              size="mini"
            />
          </el-form-item>
        </el-form>
        <el-form
          :disabled="readonly"
          label-width="135px"
          label-position="left"
          style="margin-right:10px"
        >
          <el-form-item :label="$t('SeaExport.NotifyParty')" class="auto-width">
            <cargo-company-select
              no="93"
              :disabled="readonly"
              :method-params="{notify:true,active:true}"
              :default-value="job.notifyId||''"
              placeholder=" "
              :static-options="hasChooseOwnTransceiverPermission ? privateNotifyList : null"
              :class="isZh?'shipper-input':'shipper-input-en'"
              @change="notifyChange"
            />&nbsp;
            <el-button
              no="94"
              type="primary"
              @click="billAddressDialog.visible=true"
            >{{ $t('SeaExport.CodeSearching') }}</el-button>
          </el-form-item>
          <el-form-item v-for="i in 7" :key="i" class="auto-width">
            <cargo-input
              :ref="'notifyLine'+i"
              v-model="job['notifyLine'+i]"
              no="95"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              @change="()=>wrapAddr(job,'notifyLine'+i,i+1 > 7 ? null :'notifyLine'+(i+1),200)"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),splitNotifyLine,true)"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.FreeDetension')">
            <el-input-number v-model="job.freeTime" no="96" :controls="false" style="width: 100%;" @input="val=>{job.freeDetention=val}" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ChineseDescriptionOfGoods')">
            <cargo-rich-textarea
              v-model="job.cargoChineseName"
              no="97"
              :disabled="!isEdit"
              :auto-uppercase="false"
              :auto-half-word="false"
              style="height: 65px;min-height: 65px; flex:1"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,val=>{job.cargoChineseName=val}, true, {autoUppercase:true})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')">
            <cargo-rich-textarea
              v-model="job.cargoEnglishName"
              no="98"
              :text-chars="0"
              :warning-count="-1"
              :disabled="!isEdit"
              :auto-uppercase="isUppercaseByConfig"
              style="height: 65px;min-height: 65px;flex:1"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),job.cargoEnglishName,val=>{job.cargoEnglishName=val}, isUppercaseByConfig, {autoUppercase:isUppercaseByConfig})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.HsCode')">
            <el-input
              v-model="job.hsCode"
              no="99"
              type="textarea"
              :rows="3"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),job.hsCode,val=>{job.hsCode=val})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Marks')">
            <cargo-rich-textarea
              v-model="job.mark"
              no="100"
              :text-chars="0"
              :warning-count="-1"
              :disabled="!isEdit"
              :auto-uppercase="isUppercaseByConfig"
              style="height: 65px;min-height: 65px;flex:1"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),job.mark,val=>{job.mark=val},isUppercaseByConfig, {autoUppercase:isUppercaseByConfig})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CategoryOfGoods')">
            <cargo-advance-select
              no="101"
              :select-type="TYPE_NAMES.basic_data_CargoInformation"
              :disabled="readonly"
              filterable
              :clearable="true"
              :default-value="job.cargoCode"
              :allow-create="false"
              @parentCallBack="p=>{cargoCodeChange(p.value)}"
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="job.cargoName"
              no="102"
              :disabled="!(isEdit && job.cargoCode!='' && job.cargoCode!=null)"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomsBroker')">
            <cargo-advance-select
              no="103"
              :disabled="!job.customs"
              :select-type="TYPE_NAMES.basic_data_Company"
              :data-filter-function="customsBrokerFilter"
              filterable
              :default-value="job.customsBroker||''"
              :placeholder="$t('SeaExport.PleaseTickCustomsDeclarationOption')"
              :method-params="{customsBroker:true,companyLob:'seaExport',active:true}"
              @parentCallBack="p=>{customsBrokerChangeHandler(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomsDeclarationType')">
            <cargo-advance-select
              no="customsDeclarationType"
              :disabled="!job.customs"
              :select-type="TYPE_NAMES.basic_data_CustomsDeclarationType"
              filterable
              :default-value="job.customsDeclarationType===-1?'':job.customsDeclarationType"
              :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
              @parentCallBack="p=>{job.customsDeclarationType=p.value}"
            />
          </el-form-item>
          <el-form-item v-if="!isSalesForSzfs" :label="$t('SeaExport.HaulageCompany')">
            <cargo-company-select
              no="104"
              :disabled="!job.landTransportation"
              :method-params="{truckCmp:true,active:true}"
              :default-value="job.carryingCmp||''"
              :placeholder="$t('SeaExport.PleaseTickDoorLoadingDeliveryOption')"
              :custom-style="'width:260px'"
              @change="carryingCmpChangeHandler"
            />
          </el-form-item>
          <el-form-item v-show="job.landTransportation" :label="$t('SeaExport.Door')">
            <el-select
              v-model="truckingInfo.doorName"
              no="105"
              value-key="name"
              clearable
              filterable
              :allow-create="true"
              @change="doorsChangeHandler"
            >
              <el-option
                v-for="(item,index) in doorList"
                :key="index"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-show="job.landTransportation" :label="$t('Payment.contactPerson')">
            <div style="display:flex">
              <el-input v-model="truckingInfo.doorMan" no="106" class="short-el-input" :placeholder="$t('Payment.contactPerson')" />
              <div style="width: 60px;padding:0 10px;font-size: 12px;text-align: right;">{{ $t('SeaExport.Tel') }}</div>
              <el-input v-model="truckingInfo.doorManTel" no="107" class="short-el-input" :placeholder="$t('SeaExport.Tel')" />
            </div>
          </el-form-item>
          <el-form-item v-show="job.landTransportation" :label="$t('SeaExport.DoorAddress')">
            <el-input v-model="truckingInfo.doorAddr" no="108" type="textarea" :rows="3" />
          </el-form-item>
          <el-form-item v-show="job.landTransportation" :label="$t('SeaExport.CargosExpectedArrivalDatePacking')">
            <el-date-picker
              v-model="truckingInfo.loadingDate"
              no="loadingDate"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              format="yyyy-MM-dd HH:mm"
              style="width:400px"
            />
          </el-form-item>
        </el-form>
        <el-form
          :disabled="readonly"
          label-width="100px"
          label-position="left"
        >
          <el-form-item v-if="job.destinationPortService" :label="$t('SeaExport.PortOfDestinationServices')">
            <el-checkbox
              v-model="job.dischargingPortDoor"
              no="dischargingPortDoor"
              style="display: block;"
            >{{ $t('SeaExport.DispatchVehiclesAtDestination') }}
            </el-checkbox>
            <el-checkbox
              v-model="job.destPortCustomsClearance"
              no="destPortCustomsClearance"
              style="display: block;"
            >{{ $t('SeaExport.PortOfDestinationCustomsClearance') }}
            </el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.SecondNotifyParty')" class="auto-width">
            <cargo-rich-textarea
              v-model="job.alsoNotify"
              no="109"
              :disabled="readonly"
              :text-chars="0"
              style="width: 260px;height: 216px;"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.SecondNotifyParty'),job.alsoNotify,val=>{job.alsoNotify=val},true,{warningCount:45,maxChar: 0})"
            />
          </el-form-item>
          <el-form-item class="auto-width">
            <special-requests-grid
              ref="selectedSpecialRequest"
              v-model="job.satisfiedRequests"
              :is-edit="isEdit"
              :customer-id="job.customerId"
              :lob="job.lob"
              :job="job"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Remarks')" class="auto-width">
            <el-input
              v-model="job.remarks"
              no="110"
              type="textarea"
              :rows="4"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.remarks,val=>{job.remarks=val})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.UserDefinedField1')" class="auto-width">
            <el-input v-model="job.userDefinedField1" no="111" type="textarea" :rows="4" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.UserDefinedField2')" class="auto-width">
            <el-input v-model="job.userDefinedField2" no="112" type="textarea" :rows="4" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.UserDefinedField3')" class="auto-width">
            <el-input v-model="job.userDefinedField3" no="113" type="textarea" :rows="4" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.UserDefinedField4')" class="auto-width">
            <el-input v-model="job.userDefinedField4" no="114" type="textarea" :rows="4" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.TaxNature')">
            <el-select
              v-model="job.taxNature"
              no="taxNature"
              :placeholder="$t('SeaExport.PleaseSelect')"
              size="mini"
            >
              <el-option
                v-for="(item,index) in TAX_NATURES"
                :key="index"
                :label="isZh?item.chineseName:item.englishName"
                :value="item.code"
              />
            </el-select>&nbsp;
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="job"
      :own-permission="hasChooseOwnTransceiverPermission"
      :customer-cmp-list="customerCmpList"
      :use-empty-customer-cmp-list="true"
      @callback="codeSearchCallback"
    />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="115"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="116" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tabSeBookingJS from './tabSeBooking.js'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoRequireAdvanceSelect from '@/components/Cargo/Common/cargoRequireAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import cargoRequireSelect from '@/components/Cargo/Common/cargoRequireSelect'
import cargoProjectSelect from '@/components/Cargo/Common/cargoProjectSelect'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import bookingSeaEqDataGrid from '@/components/Cargo/Job/bookingSeaEqDataGrid'
import specialRequestsGrid from '@/components/Cargo/Job/specialRequestsGrid'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { BillAddressCommonPM } from '@/class/common/BillAddressCommonPM'
import { BOOKING_TERMS } from '@/class/cargo/model/parameters/SeaExportConstants'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { Trucking } from '@/class/model/booking/Trucking'
import cargoSalesCompanySelect from '@/components/Cargo/Common/cargoSalesCompanySelect'
import { loadSpecificBasicInfo } from '@/api/cache'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect.vue'
import { RATE_TYPE, TAX_NATURES } from '@/class/cargo/model/parameters/SystemConstants'
import { cache } from '@/utils/cacheManager'

export default {
  name: 'TabSeBooking',
  components: {
    cargoOfficeSelect, cargoSalesCompanySelect,
    cargoAdvanceSelect, cargoCompanySelect, cargoUserSelect, cargoDepartmentSelect, cargoDepartmentNewSelect, cargoRequireAdvanceSelect,
    cargoInput, cargoRichTextarea, cargoPackingSelect, cargoRequireSelect, cargoProjectSelect, billAddressDialog, bookingSeaEqDataGrid, specialRequestsGrid, AutoNumberInput
  },
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    return {
      accountObjectControlMode: 0,
      salesOfficeCheck: false, // 是否按照分公司控制 (0:开启分公司过滤 1:关闭分公司过滤)
      validateCustomerSales: false,
      isSpecifiedSalesBusiness: false,
      salesCanSeeBookingAgent: false,
      openProjectConfig: false,
      isAddUserDefinedRoles: false, // 是否显示自定义岗位
      isHc: false,
      TAX_NATURES,
      rateType: RATE_TYPE,
      addrPM: new BillAddressCommonPM(this),
      job: new SeaExportJob().fillDefaultValue().getData(),
      mblDoc: new SeaCargoDoc().fillDefaultValue().getData(),
      hdoc: new SeaCargoDoc().fillDefaultValue().getData(),
      truckingInfo: new Trucking().fillDefaultValue().getData(),
      customerCmpList: null,
      contactList: [],
      csrList: null,
      cargoSalesList: null,
      salesList: null,
      txtSalesOffice: '', // 销售所在分公司
      dcList: null,
      vesselList: [],
      voyages: [],
      showBargeCustomCutoff: false,
      doorList: [],
      billAddressDialog: {
        visible: false
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        isUppercase: false,
        formatObj: {
          warningCount: -1,
          maxChar: 0,
          autoUppercase: false
        }
      },
      JobUtils,
      overseaAgentUsersList: [], // 海外客服用户列表
      OverseaCustomerUtils,
      view: this,
      needConfirmProjectNo: false,
      poNoRed: false,
      isProjectLinkedCustomer: false,
      privateShipperList: [], // 当前登录用户服务人员是自己的发货人列表
      privateConsigneeList: [], // 当前登录用户服务人员是自己的收货人列表
      privateNotifyList: [], // 当前登录用户服务人员是自己的通知人列表
      hasChooseOwnTransceiverPermission: false, // 有选择自己的收发通的权限
      userPortRoleData: {
        userDefinedRole1: null,
        userDefinedRole2: null,
        userDefinedRole3: null,
        userDefinedRole4: null,
        overseaOp: null,
        siteOp: null,
        doc: null,
        csr: null,
        op: null,
        seaLine: null,
        airline: null,
        railwayLine: null,
        creditOpen: false
      },
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isShowContactPersonDetail: false, // 海创显示详细信息
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    readonly() {
      return this.action === 'look'
    },
    isEdit() {
      return this.action !== 'look'
    },
    electricBusinessBtnEnable() {
      return !this.$checkPermission(['role_ElectricBusiness']) || this.context.user.admin
    },
    bookingAgentVisible() {
      return SalesUtil.salesCanBookingAgent(this.salesCanSeeBookingAgent)
    },
    seaEqList() {
      return this.job.seaEQ || []
    }
  },
  async created() {
    this.TYPE_NAMES = TYPE_NAMES
    this.bookingTerms = [...BOOKING_TERMS]
    this.SEUtils = SEUtils
    this.editVesselVoyageMode = 2 // 船名编辑模式
    loadSpecificBasicInfo('Vessel').then(res => {
      this.vesselList = res.data
    })
    this.notUppercaseShipperConsigneNotify = await JobUtils.uppercaseShipperConsigneNotify()
    this.isUppercaseByConfig = await JobUtils.uppercaseCargoEnglishNameAndMark() // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
  },
  methods: tabSeBookingJS.methods
}
</script>

<style scoped lang="scss">
#app .section.top::v-deep {
  .job-no-color.el-input {
    .el-input__inner {
      background: #ffffcc !important;
    }
  }
  .el-form-item__content {
    display: inline-block;
    flex-direction: unset;
  }
}
#app .section ::v-deep {
  .el-form-item__content {
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    .el-date-editor {
      width: 100%;
    }
    .short-item-input{
      width: 360px;
      display: inline-block;
      &::after{
        clear: both;
      }
      label{
        float: left;
        width: 65px;
        height: 31px;
        line-height: 31px;
        font-weight: normal;
        text-align: right;
        padding-right: 5px;
        box-sizing: border-box;
        &:nth-of-type(1){
          width: 100px;
          text-align: left;
        }
      }
      .short-input{
        float: left;
        width: 95px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        border: 1px solid #DCDFE6;
        background-color: #fff;
        .el-input{
          vertical-align: middle;
          input{
            width: 63px;
            border: none;
          }
        }
        & > span{
          width: 30px;
          vertical-align: middle;
          padding: 1px 3px 0 0;
          color: #999;
          font-size: 12px;
        }
        &:nth-of-type(1){
          margin-right: 5px;
        }
      }
      .short-input-disabled{
        background-color: #f3f4f5;
      }
    }
    input{
      //width: 260px;
    }
    .input2 {
      width: 260px;
    }
    .shipper-input{
      width: 190px;
      margin-right: 5px;
      display: inline-block;
      .cargo-advance-select-wrapper{
        width: 190px;
        input{
          width: 190px;
        }
      }
    }
    .shipper-input-en{
      width: 148px;
      margin-right: 5px;
      display: inline-block;
      .cargo-advance-select-wrapper{
        width: 148px;
        input{
          width: 148px;
        }
      }
    }
    .short-el-input{
      width: 100px;
      input{
        width: 100px;
      }
    }
    .port-item{
      input{
        width: 100%;
      }
    }
  }
  .form-item-w260 {
    .el-form-item__content {
      width: 260px;
    }
  }
  .auto-width {
    .el-form-item__content {
      width: auto;
    }
  }
  .el-checkbox {
    margin-right: 15px;
  }
  .el-radio-group{
    white-space: normal;
    .el-radio {
      margin-right: 15px;
      padding: 5px 0;
    }

  }

}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
</style>
